// src/components/Logo.js
import React from "react";

const Logo = () => {
	return (
		<div className="logo-test">
			<img alt="test for ui logo in react js" src="/images/logo.jpg" />
		</div>
	);
};

export default Logo;
